import config from '../../../config/config';
import currentTimeZone from '../../../config/timeZone';
import getRequest from '../base/get';

/**
 * Query parameters interface for PowerBank Preauth API calls.
 */
interface QueryParameters {
  limit?: number;
  [key: string]: any;
}

const powerBankPreauthApi = {
  /**
   * Fetch PowerBank Preauth list with pagination, filters, and sorting.
   * @param {QueryParameters} query - The query parameters for fetching preauths.
   * @returns {Promise<any>} Promise resolving to the preauth response.
   */
  fetchPreauthList: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { timeZone: currentTimeZone, ...query, limit: query?.limit || 20 };
    return getRequest(`${config.emsp.emspApiUrl}api/v2/powerbank-preauth`, parameters);
  },
  /**
   * Fetch filter options for PowerBank Preauth.
   * @returns {Promise<any>} Promise resolving to list filters.
   */
  fetchPreauthListFilters: (): Promise<any> => {
    return getRequest(`${config.emsp.emspApiUrl}api/v2/powerbank-preauth/list-filters`);
  },
  /**
   * Export PowerBank Preauth data.
   * @param {QueryParameters} query - The query parameters for export.
   * @returns {Promise<any>} Promise resolving to export data.
   */
  fetchPreauthExport: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { timeZone: currentTimeZone, ...query };
    return getRequest(`${config.emsp.emspApiUrl}api/v2/powerbank-preauth/export`, parameters);
  },
  /**
   * Fetch status counts for PowerBank Preauth.
   * @param {QueryParameters} query - The query parameters for status counts.
   * @returns {Promise<any>} Promise resolving to status counts response.
   */
  fetchPreauthStatusCounts: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { timeZone: currentTimeZone, ...query };
    return getRequest(`${config.emsp.emspApiUrl}api/v2/powerbank-preauth/status-counts`, parameters);
  },
  /**
   * Fetch PowerBank Preauth details by ID.
   * @param {string} preauthId - The preauth ID.
   * @returns {Promise<any>} Promise resolving to preauth details response.
   */
  fetchPreauthDetails: (preauthId: string): Promise<any> => {
    return getRequest(`${config.emsp.emspApiUrl}api/v2/powerbank-preauth/${preauthId}`);
  },
};

export default powerBankPreauthApi;
